/** Takes in the site title (as string, e-g Pcrwr _ Dashboard) from useLayoutContext, & gives back the proper site name (as string, e-g Pcrwr) */
export const getSiteTitle = (siteTitle: string): string => {
  const position = siteTitle.search(' ');
  return siteTitle.substring(0, position);
};
